/**
 * One chip vocabulary for the 8 AccessNodeStatus states (§10.7-1), plus the
 * derived "awaiting enrolment" state: a row that exists but has never been
 * issued a certificate has not completed the claim exchange, whatever its
 * stored status says. StatusBadge colours by keyword, so the labels below are
 * chosen to hit its existing buckets (active/pending/revoked/…).
 */

import type { AccessNodeStatus } from '../../services/access.service';

/** Locale date-time or an em-dash; shared by the node detail pages. */
export function fmtDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString();
}

/** True when a certificate expiry is inside the 30-day warning window (§10.7-7). */
export function certExpiringSoon(expiresAt: string | null): boolean {
  return !!expiresAt && new Date(expiresAt).getTime() - Date.now() < 30 * 86_400_000;
}

export function nodeStatusLabel(
  status: AccessNodeStatus,
  certificateSerial: string | null | undefined,
): string {
  if (!certificateSerial && status !== 'decommissioned' && status !== 'revoked') {
    return 'awaiting enrolment';
  }
  switch (status) {
    case 'pending_approval':
      return 'pending approval';
    case 'provisioned':
      return 'enrolled';
    default:
      return status;
  }
}
